import { Asset } from 'app-lib/assetUtils'
import { links } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { Button } from 'ui-framework'
import StakingFormVM from '../StakingFormVM'
import InputStake from './InputStake'

export function Stake({ vm }: { vm: StakingFormVM }) {
  const { wallet } = vm.stakingStore.userBalances
  const { stakingAllowances } = vm.stakingStore

  if (!vm.stakingStore.hasEnoughToStake) {
    return null
  }

  return (
    <div className="panel--simple padded-2">
      <h3 className="title-section">Add to Staking Balance</h3>

      {wallet.ooki.gte(0.01) && stakingAllowances.ooki.amount.gte(wallet.ooki) && (
        <InputStake
          id="ooki"
          max={wallet.ooki}
          onChange={vm.changeTokenBalance}
          value={vm.ookiInput}
          asset={Asset.OOKI}
        />
      )}
      {wallet.vbzrx.gte(0.01) && stakingAllowances.vbzrx.amount.gte(wallet.vbzrx) && (
        <InputStake
          id="vbzrx"
          max={wallet.vbzrx}
          onChange={vm.changeTokenBalance}
          value={vm.vbzrxInput}
          asset={Asset.vBZRX}
        />
      )}
      {wallet.iooki.gte(0.01) && stakingAllowances.iooki.amount.gte(wallet.iooki) && (
        <InputStake
          id="iooki"
          max={wallet.iooki}
          onChange={vm.changeTokenBalance}
          value={vm.iookiInput}
          asset={Asset.IOOKI}
        />
      )}
      {wallet.slp_ooki_eth.gte(0.01) &&
        stakingAllowances.slp_ooki_eth.amount.gte(wallet.slp_ooki_eth) && (
          <InputStake
            id="slp_ooki_eth"
            max={wallet.slp_ooki_eth}
            onChange={vm.changeTokenBalance}
            value={vm.slp_ooki_ethInput}
            asset={Asset.SLP_OOKI_ETH}
          />
        )}

      {stakingAllowances.needApprovalList.length < 4 && (
        <Button
          isLoading={vm.stakingStore.stakingPending}
          variant="blue"
          block
          disabled={!vm.canStake}
          onClick={vm.stake}>
          Stake
        </Button>
      )}

      {vm.stakingStore.dao.userShouldVote && (
        <div className="margin-top-2">
          <h4 className="txt-title">Important: vote before you stake!</h4>
          <p className="txt-explanation txt-warning">
            We recommend you to{' '}
            <ExternalLink className="link" href={links.tally}>
              cast your vote
            </ExternalLink>{' '}
            for the ongoing DAO proposals first. If you stake more tokens before voting onchain, you
            will not be able to vote for the ongoing proposals (due to technical limitations).
          </p>
        </div>
      )}
    </div>
  )
}

export default observer(Stake)
